import ImageMapping from 'global/components/swipe/ImageMapping'
import React, { useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'

export const MapLabel = ({ propKey, prop_value, onClick }) => {

  const [showMap, setShowMap] = useState()

  const handleShowMap = () => setShowMap(!showMap)

  console.log('prop_value', propKey, prop_value)

  if (showMap) {
    return <ImageMapping />
  } else {
    return <Label color={'blue'} icon onClick={e => onClick(propKey)}><Icon name={'map'} />{prop_value}</Label>
  }


}
